module.exports = "<table class=\"list\">\n  <tr class=\"list\">\n    <th>Address</th>\n    <th>Paid in USD</th>\n  </tr>\n  <tr *ngFor=\"let cashOut of cashOuts | async\" class=\"list\">\n    <td>{{cashOut.userId}}</td>\n    <td>{{cashOut.amountInUsd | number:'0.2-5'}}</td>\n  </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cash-outs/cash-outs.component.html
// module id = ./src/app/cash-outs/cash-outs.component.html
// module chunks = main